import fetch from 'isomorphic-fetch';
import qs from 'query-string';

import {
  START_SALE_FAILURE,
  START_SALE_REQUEST,
  START_SALE_SUCCESS,
  START_SALE_TIMEOUT
} from '../constants/ActionTypes';
import { checkStatus, parseJSON, dispatchError } from '../utils/fetch';

function startSaleRequest(sale) {
  return {
    type: START_SALE_REQUEST,
    sale
  };
}

function startSaleFailure(error, errors) {
  return {
    type: START_SALE_FAILURE,
    error,
    errors
  };
}

function startSaleSuccess(id) {
  return {
    type: START_SALE_SUCCESS,
    sale: {
      id
    },
    date: new Date(),
    timeout: setTimeout(startSaleTimeout, 5000)
  };
}

function startSaleTimeout() {
  return {
    type: START_SALE_TIMEOUT
  };
}

export default function startSale() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { config, sale } = getState();

      dispatch(startSaleRequest());

      if (sale.sale.id != null) {
        dispatch(startSaleSuccess(sale.sale.id));
        return resolve();
      }

      fetch(
        `${config.apiUrl}/sales?${qs.stringify({
          client: config.client
        })}`,
        {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      )
        .then(checkStatus)
        .then(parseJSON)
        .then(id => {
          dispatch(startSaleSuccess(id));
          resolve(id);
          return id;
        })
        .catch((...args) => {
          dispatchError(dispatch, startSaleFailure)(...args);
          reject(...args);
        });
    });
}
